<template>
  <div class="tab-other">
    <el-row>
      <el-col :span="3" style="height: 80px; line-height: 60px; text-align: right;">版型</el-col>
      <el-col :span="21">
        <el-row>
          <base-checkbox
            :label-width="labelConfig.labedWidth"
            :readOnly="readOnly"
            v-model="info.pattern"
            label="上装"
            :options="patternOptionsUp"
            :multiple="true"
            :max="1"
          ></base-checkbox>
        </el-row>
        <el-row>
          <base-checkbox
            :label-width="labelConfig.labedWidth"
            :readOnly="readOnly"
            v-model="info.pattern"
            label="下装"
            :options="patternOptionsDown"
            :multiple="true"
            :max="1"
          ></base-checkbox>
        </el-row>

      </el-col>
      <!-- <el-col :span="20">
        <base-checkbox
          :label-width="labelConfig.labedWidth"
          :readOnly="readOnly"
          v-model="info.pattern"
          label="版型"
          :options="patternOptions"
          :multiple="true"
          :max="1"
        ></base-checkbox>
      </el-col> -->
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          v-model="info.cuttingDescription"
          :rows="rows"
          type="textarea"
          label="裁剪说明"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.specialProcessDescription"
          type="textarea"
          label="特殊工艺说明"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.sewingDescription"
          type="textarea"
          label="缝制说明"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.sampleQuantityDescription"
          type="textarea"
          label="样衣数量说明"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.ironDescription"
          type="textarea"
          label="整烫说明"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.needleRequire"
          type="textarea"
          label="针距要求"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.qualityRequirementsDescription"
          type="textarea"
          label="大货缝制重点及收货标准"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.bumpDescription"
          type="textarea"
          label="撞料说明"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.packageDescription"
          type="textarea"
          label="后整要求"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :label-width="labelConfig.labedWidth"
          :disabled="readOnly"
          :rows="rows"
          v-model="info.sampleWashEffect"
          type="textarea"
          label="样衣洗水效果"
          style="width: 805px;"
        ></base-string>
      </el-col>
    
    </el-row>
  </div>
</template>
<script>
export default {
  name: "tab-other",
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {},
  data() {
    return {
      labelConfig: {
        readOnly: true,
        labedWidth: 200
      },
      rows: 6,
      list: [],
      patternOptionsDown: [
        {
          comment: '高腰',
          code: '高腰'
        },
        {
          comment: '中腰',
          code: '中腰'
        },
        {
          comment: '低腰',
          code: '低腰'
        },
      ],
      patternOptionsUp: [
        {
          comment: '紧身',
          code: '紧身'
        },
        {
          comment: '合体',
          code: '合体'
        },
        {
          comment: '宽松',
          code: '宽松'
        },
        {
          comment: 'Oversize',
          code: 'Oversize'
        },
      ]
    };
  }
};
</script>

<style scoped>
</style>
